import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RoleEntitySchema, type PatchRoleInput, type RoleEntity } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function usePatchRole(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<RoleEntity, unknown, PatchRoleInput>({
    mutationFn: (input) => client.patch<RoleEntity>(`/roles/${id}`, input, {}, RoleEntitySchema),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['roles', 'admin-list'] });
      qc.invalidateQueries({ queryKey: ['roles', 'list'] });
      qc.invalidateQueries({ queryKey: ['role', id] });
    },
  });
}
